<template>
    <div>
        <!-- 要保人變更 -->
        <Layout
            :header="{ text: '申請內容', backBtn: { visible: true }, closeBtn: { visible: true, to: { name: routeName.CLOUD_E_COUNTER_HOME } }, }">

            <h2 class="pb-8 text-2xl font-bold">
                申請明細
            </h2>

            <div class="pb-6">
                <h3 class="pb-4 text-xl font-bold">
                    申請保單
                </h3>
                <CaseBox :caseBox="policyInfo"></CaseBox>
            </div>

            <div class="pb-6">
                <h3 class="pb-4 text-xl font-bold">
                    新的要保人資料
                </h3>
                <CaseBox :caseBox="newApplicantName"></CaseBox>
            </div>

            <div class="pb-4" v-if="exemptRiderList && exemptRiderList.length > 0">
                <h3 class="pb-4 text-xl font-bold">
                    取消豁免附約
                </h3>
                <CaseBox class="font-bold">
                    <template v-for="(e) in exemptRiderList">
                        <a href="#">{{ `${e.name} （${e.item}）` }}</a>
                    </template>
                </CaseBox>
            </div>

            <div class="pb-2">
                <CaseBox :caseBox="endoresmentContent" />
            </div>

            <div v-if="canCancel" class="text-center">
                <button class="py-3 text-[#EB4751] text-sm" @click="(e) => { infoBoxVisble = true }">取消預約申請
                </button>
            </div>
            <Loading :is-loading="isLoading" />
        </Layout>

        <InfoBox v-show="infoBoxVisble" :closeHandel="() => { infoBoxVisble = false; }" title="確定要取消預約申請嗎？"
            type="confirm" :okHandel="okHandel" :buttonText="{ no: '保留預約', yes: '取消預約' }">
        </InfoBox>
    </div>
</template>

<script setup>
import '@/assets/cloudCounter/css/style.css';
import { onMounted, ref } from 'vue';
import Layout from '@/components/cloudCounter/Layout.vue';
import CaseBox from '@/components/cloudCounter/CaseBox.vue';
import InfoBox from '@/components/cloudCounter/InfoBox.vue';
import { useRoute } from 'vue-router';
import { postCancelTransaction, postCecRecord } from '@/apis/record';
import { convertCaseBoxList, setBoxData } from '@/views/cloudECounter/reserve/record/caseBoxUtils';
import applicantField from '@/views/cloudECounter/reserve/record/applicantField';
import { openPopup, openPopupCatchMessage } from '@/utils/vfmUtils';
import Loading from '@/components/Loading.vue';
import routeName from '@/router/constant';

const route = useRoute();
const regiNo = ref(route.query?.regiNo);
const policyInfo = ref(null);
const isLoading = ref(true);
const newApplicantName = ref({
    boxList: [
        {
            title: '',
            list: [],
        },
        {
            title: '',
            list: [],
        },
        {
            title: '',
            list: [],
        },
    ],
});
const exemptRiderList = ref([]);
const canCancel = ref(false);
const endoresmentContent = ref({
    boxList: [{
        title: '本次變更批註寄送方式',
        list: [{
            key: '',
            value: '',
        }],
    }],
});

const infoBoxVisble = ref(false);
const okHandel = () => {
    isLoading.value = true;
    postCancelTransaction(regiNo.value).then(res => {
        openPopup('已完成取消預約申請');
        canCancel.value = false;
    }).catch(ex => {
        openPopupCatchMessage(ex);
    }).finally(() => {
        isLoading.value = false;
    });
};

onMounted(() => {
    postCecRecord(regiNo.value).then(res => {
        // record.value.boxList = convertCaseBoxList(res.data, applicantField.record);
        policyInfo.value = setBoxData(res?.data?.fullPolicyNo, `${res?.data?.item} ${res?.data?.itemName}`);
        const a = res.data.applicantChange.after;
        newApplicantName.value.boxList = convertCaseBoxList([
            a.applicantDataInfo,
            a.professionInfo,
            getConnectionInfo(a)], [
            applicantField.applicantDataInfo,
            applicantField.profession,
            applicantField.connectionInfo]);
        exemptRiderList.value = res.data.applicantChange.exemptRiderList;
        canCancel.value = res.data.canCancel;
        if (res.data?.applicantChange?.insuredMobile) {
            newApplicantName.value.boxList.push({
                title: '被保險人行動電話',
                list: [{
                    key: '行動電話',
                    value: res.data?.applicantChange?.insuredMobile.mobile
                }]
            })
        }

        if (res.data?.applicantChange?.insMobile) {
            newApplicantName.value.boxList.push({
                title: '原要保人行動電話',
                list: [{
                    key: '行動電話',
                    value: res.data?.applicantChange?.insMobile.mobile
                }]
            })
        }
        endoresmentContent.value.boxList[0].list[0].value = res.data?.endorsementDesc;
    }).catch(ex => {
        console.log(ex);
        openPopupCatchMessage(ex);
    }).finally(() => {
        isLoading.value = false;
    });
});

const convertTel = (telAreaCode, tel, telExt) => {
    let returnTel = ''

    if (telAreaCode && tel) {
        returnTel = `${telAreaCode}-${tel}`
    }
    if (telExt) {
        returnTel = `${returnTel} #${telExt}`
    }

    return returnTel;
}

const getConnectionInfo = (a) => {
    return {
        applicantInfoAddress: `${a?.applicantInfo?.city}${a?.applicantInfo?.cityArea}${a?.applicantInfo?.address}`,
        applicantInfoTel: convertTel(a?.applicantInfo?.telAreaCode, a?.applicantInfo?.tel, a?.applicantInfo?.telExt),
        chargeInfoAddress: `${a?.chargeInfo?.city}${a?.chargeInfo?.cityArea}${a?.chargeInfo?.address}`,
        chargeInfoTel: convertTel(a?.chargeInfo?.telAreaCode, a?.chargeInfo?.tel, a?.chargeInfo?.telExt),
        mobile: a.mobile,
        email: a.email,
    };
};
</script>

<style scoped></style>
